import React from "react";
import "./Turfdetails.css";

const services = [
  {
    title: "Paver Patios & Walkways",
    text:
      "We install custom paver patios and walkways, beginning with proper base preparation and grading. Using a range of patterns, layouts, and materials, pavers are placed precisely to create designs and a level, durable surface built to last.",
  },
  {
    title: "Artificial Turf",
    text:
      "We prepare each site and install turf with base work and layout planning. Materials are positioned carefully for a clean, finished appearance. Installation steps are reviewed to ensure efficiency, consistency, durability, and performance.",
  },
  {
    title: "Outdoor Living Areas",
    text:
      "We manage outdoor living area construction with transparent communication from planning through completion. Sites are evaluated, prepared, and leveled to specification. Structural bases are installed, compacted, and verified to support safe performance.",
  },
];

export default function Turfdetails() {
  return (
    <section className="turfdetails">
      <div className="turfdetails__container">
        <header className="turfdetails__header">
          <h2 className="turfdetails__title">
            Tailored Hardscape Solutions
          </h2>

          <div className="rl-title-underline"></div>

          <p className="turfdetails__subtitle">
            We install pavers, turf, and outdoor living areas for residential and
            commercial properties, emphasizing detail, durability, and
            performance designed to enhance function overall.
          </p>
        </header>

        <div className="turfdetails__grid">
          {services.map(({ title, text }) => (
            <article key={title} className="turfdetails__card">
              <div className="turfdetails__card-content">
                <h2 className="turfdetails__card-title">{title}</h2>
                <p className="turfdetails__card-text">{text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
